/* eslint-disable max-len */
/* eslint-disable  react/jsx-indent */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GenericListPair from 'modules/common/components/GenericListPair';
import { Acl } from 'modules/common/components/Acl';
import { ModalContext } from 'App';
import { getJson } from 'session';
import useDebounce from 'modules/common/components/UseDebounce';
import ToggleFetcherTimer from 'modules/common/components/ToggleFetcherTimer';
import * as actions from './action';
import * as c from './constant';
import TransactionContent from './TransactionContent';

const form = {
  keyword: '',
  transaction_status: '',
  start_date: '',
  end_date: '',
  module_type: 'T_BPLS',
  transaction_type: 'QUARTERLY',
};

function TransactionContainer({
  getTransactionList,
  transactionList,
  transactionListPager,
  match,
  isLoading,
  history,
  permissions,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(form);
  const [filter, setFilter] = useState(form);
  const [countChar, setCountChar] = useState(0);

  const UpdateData = () => {
    getTransactionList();
    return () => {
      setModal({ isOpen: false });
    };
  };

  const param = {
    module_type: 'T_BPLS',
    transaction_type: 'QUARTERLY',
    q: formData.keyword,
    sort_by: 'asc',
  };

  const handleOnChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setCountChar(e.target.value.length);
  };

  useEffect(() => {
    UpdateData();
  }, []);

  const handleOnChangeSelect = key => e => {
    setFilter({
      ...filter,
      [key]: e.value,
      transaction_status: e.value,
    });
    getTransactionList({ ...filter, transaction_status: e.value });
  };

  const debouncedSearchTerm = useDebounce(formData, 500);
  useEffect(() => {
    if (debouncedSearchTerm && countChar >= 3) {
      getTransactionList({
        module_type: 'T_BPLS',
        q: formData.keyword,
        transaction_type: 'QUARTERLY',
      });
    } else {
      getTransactionList({
        module_type: 'T_BPLS',
        transaction_type: 'QUARTERLY',
      });
    }
  }, [debouncedSearchTerm]);

  const onCallbackTimer = () => {
    getTransactionList({
      module_type: 'T_BPLS',
      q: formData.keyword,
      transaction_status: filter.transaction_status,
      transaction_type: 'QUARTERLY',
    });
  };

  return (
    <div className="card-content-listing" style={{ paddingTop: '0px' }}>
      {Acl(permissions, ['VIEW TRANSMITTAL']) && (
        <div className="transmital">
          <ToggleFetcherTimer callback={onCallbackTimer} />
        </div>
      )}

      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Quarterly Applications"
            getData={getTransactionList}
            setParams={param}
            setKeyword={handleOnChange}
            setStatusFilter={handleOnChangeSelect(
              _.get(formData, 'transaction_status')
            )}
            statusOptions={c.APPLICATION_STATUS}
            status={_.get(filter, 'transaction_status') || ''}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search Transaction..."
            pathName={`${match.path}/:id?`}
            listName="Transaction"
            label="Transaction List"
            renderItem={item => (
              <div className="px-3 py-3">
                <div className="transaction-list-company">
                  {_.get(item, 'included.module.attributes.business_name')}
                </div>
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {_.get(item, 'included.module.attributes.bin') || ''}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            statusFilter
            selected={params.id}
            data={transactionList}
            dataPager={transactionListPager}
            handleSelectRow={data => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() => (
                      <TransactionContent UpdateData={UpdateData} />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:id?`}
                  render={() =>
                    !params.business_Id && transactionList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(transactionList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

TransactionContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  //  showTransaction: PropTypes.instanceOf(Function).isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array).isRequired,
  transactionListPager: PropTypes.instanceOf(Object).isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionList: _.get(api, `${c.GET_TRANSACTION}.list`) || [],
  transactionListPager: _.get(api, `${c.GET_TRANSACTION}.pager`) || {},
  isLoading: api.loading.indexOf(c.GET_TRANSACTION) > -1,
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TransactionContainer);
